import { getAuth0 } from './get-auth0';
import { getUserProfileFromCookies } from './getUserProfileFromCookies';

export const authenticateUser = async () => {
  const auth0 = getAuth0();
  if (!auth0) return;

  const token = await auth0.getTokenIfAuthenticated();
  if (!token) return;

  const userProfile = getUserProfileFromCookies();

  return userProfile;
};
